import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "@/lib/products";
import Footer from "@/components/Footer";

export default function LegalLayout({ title, lastUpdated, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="legal-page" className="min-h-screen bg-white flex flex-col">
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-slate-200">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            data-testid="legal-brand-link"
            className="flex items-center gap-3"
          >
            <img
              src={BRAND.logo}
              alt={BRAND.name}
              className="h-11 md:h-12 w-auto object-contain rounded-lg"
            />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-bold text-[#1e3a8a] hover:text-[#172554] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <div className="container mx-auto px-4 md:px-8 max-w-3xl py-12 md:py-16">
          <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900">
            {title}
          </h1>
          {lastUpdated && (
            <p className="mt-2 text-sm text-slate-500">
              Last updated: {lastUpdated}
            </p>
          )}
          <div className="mt-8 text-slate-700 leading-relaxed">{children}</div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section className="mt-8 first:mt-0">
      {heading && (
        <h2 className="font-display text-xl font-bold text-slate-900 mb-3">
          {heading}
        </h2>
      )}
      <div className="space-y-3">{children}</div>
    </section>
  );
}
